/**
 * Domain error represents a validation failure.
 */
export default class ValidationError extends Error {
	public field: string;
	public message_code: string;
	public validated_data: any;
	public property_path?: string;
	public received_value?: any;
	public field_limit?: any;
	public valid_values?: any[];
	public multilingual_field_path?: string;

	constructor(
		field: string,
		message_code: string,
		validated_data: any,
		extra_data?: {
			property_path?: string;
			received_value?: any;
			field_limit?: any;
			valid_values?: any[];
			multilingual_field_path?: string;
		}
	) {
		// Calling the base Error constructor with the message code
		super(message_code);

		this.field = field;
		this.message_code = message_code;
		this.validated_data = validated_data;

		// Mapping extra data if provided
		if (extra_data) {
			this.property_path = extra_data.property_path;
			this.received_value = extra_data.received_value;
			this.field_limit = extra_data.field_limit;
			this.valid_values = extra_data.valid_values;
			this.multilingual_field_path = extra_data.multilingual_field_path;
		}

		// Set the prototype explicitly for extending built-in Error in TS
		Object.setPrototypeOf(this, ValidationError.prototype);
	}
}
